import { getExpressionFutureData, getExpressionPastData, getTagFutureData, getTagsPastData } from "api/dashboard";

const areaApiConfig = {
  getTagsPastData,
  getTagFutureData,
  getExpressionPastData,
  getExpressionFutureData
};

export default areaApiConfig;